import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, isValidElement } from 'react';
import classnames from 'classnames';
import { isFunc, isString } from '../utils/is';
import { listClass } from './styles';
import Image from '../Image';

var metaClass = function metaClass() {
  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }

  return listClass.apply(void 0, _toConsumableArray(a.map(function (v) {
    return "meta-".concat(v);
  })));
};

var Meta =
/*#__PURE__*/
function (_Component) {
  _inherits(Meta, _Component);

  var _super = _createSuper2(Meta);

  function Meta() {
    _classCallCheck(this, Meta);

    return _super.apply(this, arguments);
  }

  _createClass(Meta, [{
    key: "renderAvatar",
    value: function renderAvatar() {
      var avatar = this.props.avatar;
      if (!avatar) return null;

      if (
      /*#__PURE__*/
      isValidElement(avatar)) {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: metaClass('avatar')
          }, avatar)
        );
      }

      if (isFunc(avatar)) {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: metaClass('avatar')
          }, avatar())
        );
      }

      if (isString(avatar)) return (
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('avatar')
        },
        /*#__PURE__*/
        React.createElement(Image, {
          lazy: true,
          src: avatar
        }))
      );
      return null;
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props = this.props,
          title = _this$props.title,
          desc = _this$props.desc;
      if (!title) return null;
      var flag = !desc;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('title', flag && 'center')
        }, title)
      );
    }
  }, {
    key: "renderDesc",
    value: function renderDesc() {
      var _this$props2 = this.props,
          desc = _this$props2.desc,
          title = _this$props2.title;
      if (!desc) return null;
      var flag = !title;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('desc', flag && 'center')
        }, desc)
      );
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var content = this.props.content;
      if (!content) return null;
      if (isFunc(content)) return (
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('content')
        }, content())
      );
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('content')
        }, content)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          content = _this$props3.content,
          title = _this$props3.title,
          desc = _this$props3.desc; // if content && title && desc is all null, just render avatar

      if (!content && !title && !desc) {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: classnames(listClass('meta'), className)
          }, this.renderAvatar())
        );
      } // if title && desc is null, render classic layout


      if (!title && !desc) {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: classnames(listClass('meta', 'includes'), className)
          }, this.renderAvatar(), this.renderContent())
        );
      } // full layout


      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(listClass('meta'), className)
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('container')
        }, this.renderAvatar(),
        /*#__PURE__*/
        React.createElement("div", {
          className: metaClass('meta')
        }, this.renderTitle(), this.renderDesc())), this.renderContent())
      );
    }
  }]);

  return Meta;
}(Component);

export default Meta;